// extracted by mini-css-extract-plugin
export default {"upload":"style_upload__zE-8M","uploadPhoto":"style_uploadPhoto__7um-g"};